import { api } from '../utils/auth';

// Бесплатные инструменты (ТРГ из КЛКТ, ориентация и наложение). Загрузка и скачивание больших файлов могут
// идти долго, поэтому таймауты большие; сам опрос статуса использует обычный короткий таймаут.
const LONG = 30 * 60 * 1000;

const makeApi = (base) => ({
  start: async (kind, formData, onProgress) => (await api.post(`${base}/${kind}`, formData, {
    timeout: LONG,
    onUploadProgress: (e) => { if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total)); },
  })).data,
  rerun: async (taskId, params) => {
    const body = new FormData();
    Object.entries(params || {}).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') body.append(k, v); });
    return (await api.post(`${base}/rerun/${taskId}`, body, { timeout: 60000 })).data;
  },
  status: async (taskId) => (await api.get(`${base}/status/${taskId}`, { timeout: 30000 })).data,
  results: async (taskId) => (await api.get(`${base}/results/${taskId}`, { timeout: 30000 })).data,
  cancel: async (taskId) => (await api.post(`${base}/cancel/${taskId}`, null, { timeout: 30000 })).data,
  download: async (taskId, name) => (await api.get(`${base}/download/${taskId}/${name}`, {
    responseType: 'blob', timeout: LONG,
  })).data,
});

export const toolsApi = makeApi('/tools');
// Полная сегментация и отчёт по КЛКТ (пока только администратор)
export const instrumentsApi = makeApi('/instruments');

export const saveBlob = (blob, name) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
};
